import React, { useState } from "react"
import PropTypes from "prop-types"
import { Modal, ModalBody, ModalHeader } from "reactstrap"
import { subjectsPropTypes } from "../../utils/propTypes"
import CreateEditCaseEnhanced from "../CreateEditCase/CreateEditCaseEnhanced"
import "./EditCaseModal.scss"

const EditCaseModal = (props) => {
  const [modalOpen, setModalOpen] = useState(props.modalOpen)

  const closeButton = (
    <button
      type="button"
      title="button"
      className="close-button fa fa-times"
      onClick={() => setModalOpen(!modalOpen)}
    />
  )

  const onSuccess = () => {
    setModalOpen(false)
  }

  return (
    <div className="EditCaseModal">
      <button
        className="open"
        type="button"
        title="open"
        onClick={(e) => {
          e.stopPropagation()
          setModalOpen(!modalOpen)
        }}
      >
        <i className="fa fa-pencil" />
        {" Edit Info"}
      </button>
      <Modal isOpen={modalOpen} className="EditCaseModal">
        <ModalHeader close={closeButton}>
          Edit Case #{props.internalId}
        </ModalHeader>
        <ModalBody>
          {modalOpen &&
            React.createElement(props.bodyElement, {
              id: props.id,
              internalId: props.internalId,
              caseType: props.caseType,
              subjects: props.subjects,
              onSuccess: onSuccess,
              onCancel: onSuccess,
              usePreviousSubjectEndAt: false,
            })}
        </ModalBody>
      </Modal>
    </div>
  )
}

EditCaseModal.propTypes = {
  modalOpen: PropTypes.bool.isRequired,
  id: PropTypes.string.isRequired,
  internalId: PropTypes.string.isRequired,
  caseType: PropTypes.oneOf(["patientPositive", "employeePositive"]).isRequired,
  subjects: subjectsPropTypes.isRequired,
  bodyElement: PropTypes.elementType,
}

EditCaseModal.defaultProps = {
  modalOpen: false,
  bodyElement: CreateEditCaseEnhanced,
}

export default EditCaseModal
